import { render } from "./Fourth.vue?vue&type=template&id=7ec4065f&scoped=true"
import script from "./Fourth.vue?vue&type=script&lang=js"
export * from "./Fourth.vue?vue&type=script&lang=js"

import "./Fourth.vue?vue&type=style&index=0&id=7ec4065f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec4065f"]])

export default __exports__